import { useShallow } from "zustand/react/shallow"

import { createPersistedCredential } from "@src/features/webauthn/lib/createPersistedCredential"
import { getCredential } from "@src/features/webauthn/lib/webAuthnCredentialService"
import {
  type SignMessageOptions,
  type WebauthnCredential,
  signIn,
  signMessage,
} from "@src/features/webauthn/lib/webauthnService"

import { createWebAuthnStore } from "../lib/createWebAuthnStore"

export const useWebAuthnStore = createWebAuthnStore<
  WebauthnCredential,
  AuthenticatorAssertionResponse,
  Uint8Array,
  SignMessageOptions
>({
  async signIn() {
    const rawId = await signIn()
    return getCredential(rawId)
  },
  async createNew(passkeyName) {
    const { credential } = await createPersistedCredential(passkeyName, {
      allowPrfFallback: true,
    })
    return credential
  },
  async signMessage(challenge, credential, options) {
    return signMessage(challenge, credential, options)
  },
})

export function useWebAuthnActions() {
  return useWebAuthnStore(
    useShallow((state: ReturnType<typeof useWebAuthnStore.getState>) => ({
      signIn: state.signIn,
      createNew: state.createNew,
      signMessage: state.signMessage,
      signOut: state.signOut,
    }))
  )
}

export function useWebAuthnCurrentCredential() {
  return useWebAuthnStore((state) => state.credential)
}

export { useWebAuthnUIStore } from "./useWebAuthnUiStore"
